var _path, _g, _circle, _path2, _path3, _ellipse, _path4, _path5, _circle2, _path6, _path7, _ellipse2, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 97,
    viewBox: "0 0 84 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.880649 13.5208C0.670692 12.3301 1.46576 11.1946 2.65648 10.9847L54.4004 1.86083C55.5911 1.65087 56.7266 2.44594 56.9366 3.63667L69.4818 74.7845C69.6918 75.9753 68.8967 77.1108 67.706 77.3207L15.9621 86.4446C14.7714 86.6545 13.6359 85.8594 13.4259 84.6687L0.880649 13.5208Z",
    fill: "#7075E9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1605_3348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7131 14.8781C21.7553 13.6698 22.7691 12.7244 23.9775 12.7666L76.4876 14.6003C77.696 14.6425 78.6413 15.6563 78.5991 16.8646L76.0778 89.0661C76.0356 90.2745 75.0218 91.2198 73.8135 91.1776L21.3033 89.3439C20.095 89.3017 19.1496 88.288 19.1918 87.0796L21.7131 14.8781Z",
    fill: "#F1F2FE",
    fillOpacity: 0.88
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6873,
    cy: 24.5016,
    r: 2.73657,
    transform: "rotate(2 30.6873 24.5016)",
    fill: "#7075E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6293 24.1265C35.6504 23.5223 36.1573 23.0497 36.7614 23.0708L52.0769 23.6056C52.6811 23.6267 53.1538 24.1336 53.1327 24.7378L53.0945 25.8317C53.0734 26.4359 52.5665 26.9086 51.9623 26.8875L36.6468 26.3526C36.0427 26.3315 35.57 25.8247 35.5911 25.2205L35.6293 24.1265Z",
    fill: "#C6C9F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9784 25.0815C62.9995 24.4774 63.5064 24.0047 64.1106 24.0258L70.6743 24.255C71.2785 24.2761 71.7512 24.783 71.7301 25.3872L71.6919 26.4811C71.6708 27.0853 71.1639 27.558 70.5597 27.5369L63.996 27.3077C63.3918 27.2866 62.9191 26.7797 62.9402 26.1755L62.9784 25.0815Z",
    fill: "#C6C9F4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.9993,
    cy: 44.193,
    rx: 2.73657,
    ry: 2.73657,
    transform: "rotate(2 29.9993 44.193)",
    fill: "#7075E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9413 43.8177C34.9624 43.2136 35.4693 42.7409 36.0735 42.762L47.0131 43.144C47.6172 43.1651 48.0899 43.672 48.0688 44.2762L48.0306 45.3701C48.0095 45.9743 47.5026 46.447 46.8985 46.4259L35.9588 46.0439C35.3547 46.0228 34.882 45.5159 34.9031 44.9117L34.9413 43.8177Z",
    fill: "#C6C9F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2904 44.7728C62.3115 44.1686 62.8184 43.696 63.4226 43.7171L69.9863 43.9463C70.5905 43.9674 71.0632 44.4743 71.0421 45.0784L71.0039 46.1724C70.9828 46.7766 70.4759 47.2493 69.8717 47.2282L63.308 46.9989C62.7038 46.9778 62.2311 46.471 62.2522 45.8668L62.2904 44.7728Z",
    fill: "#C6C9F4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.3435,
    cy: 34.3472,
    r: 2.73657,
    transform: "rotate(2 30.3435 34.3472)",
    fill: "#7075E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2855 33.9721C35.3066 33.3679 35.8135 32.8952 36.4177 32.9163L49.5452 33.3748C50.1494 33.3959 50.6221 33.9028 50.601 34.5069L50.5628 35.6009C50.5417 36.2051 50.0348 36.6778 49.4306 36.6567L36.3031 36.1982C35.6989 36.1771 35.2262 35.6703 35.2473 35.0661L35.2855 33.9721Z",
    fill: "#C6C9F4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8221 35.0036C64.8432 34.3994 65.3501 33.9267 65.9543 33.9478L70.3302 34.1006C70.9344 34.1217 71.407 34.6286 71.3859 35.2328L71.3477 36.3268C71.3266 36.931 70.8198 37.4036 70.2156 37.3825L65.8397 37.2297C65.2355 37.2086 64.7628 36.7017 64.7839 36.0976L64.8221 35.0036Z",
    fill: "#C6C9F4"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.6555,
    cy: 54.0385,
    rx: 2.73657,
    ry: 2.73657,
    transform: "rotate(2 29.6555 54.0385)",
    fill: "#7075E9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5975 53.6635C34.6186 53.0593 35.1255 52.5866 35.7297 52.6077L48.8572 53.0661C49.4614 53.0872 49.9341 53.5941 49.913 54.1983L49.8748 55.2923C49.8537 55.8964 49.3468 56.3691 48.7426 56.348L35.6151 55.8896C35.0109 55.8685 34.5382 55.3616 34.5593 54.7574L34.5975 53.6635Z",
    fill: "#C6C9F4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1342 54.6949C64.1553 54.0907 64.6621 53.6181 65.2663 53.6392L69.6422 53.792C70.2463 53.8131 70.719 54.3199 70.6979 54.9241L70.6597 56.0181C70.6386 56.6223 70.1317 57.095 69.5276 57.0739L65.1517 56.921C64.5475 56.8999 64.0749 56.3931 64.096 55.7889L64.1342 54.6949Z",
    fill: "#C6C9F4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1605_3348",
    x: 14.0707,
    y: 7.64555,
    width: 69.6496,
    height: 88.6532,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2.55986
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1605_3348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1605_3348",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.366d06bae881922b4ed3d4b74abe974a.svg";
export { ForwardRef as ReactComponent };